/**
 * Closings list view.
 * @constructor
 * 
 * @param {string} type Closing type.
 */
window.ClosingsList = function(type){
	
	console.log(type);
	
	this.type = type;
	
	this.$listing_container = $('#' + this.type + '_closingsListing_container');
	this.$filters_form		= $('#' + this.type + '_closingsFilterForm');
	
	this.prepareFiltersForm();
	this.bindEvents();
};

/**
 * Prepare filters form for current DOM.
 * 
 * @return {void}
 */
window.ClosingsList.prototype.prepareFiltersForm = function(){
	
	MyForm.prepare(this.type + '_closingsFilterForm', 'pos_' + this.type + 'Closings&action=updateListing', {
		
		success		: function (data) {
			
			Listing.refresh(this.type + "_closingsListing", data, data[this.type + '_closings_metadatas']);
			return;
		}.bind(this),
		
		dataType	: 'json'
	});
	
	return;
};

/**
 * Bind all events.
 * 
 * @return {void}
 */
window.ClosingsList.prototype.bindEvents = function(){
	
	$('#' + this.type + '_closingsListing_cashtill', this.$filters_form).change(this.update.bind(this));
	this.$listing_container.on('click', 'tbody tr', this.openPanel.bind(this));
	
	return;
};

/**
 * Update listing view. Triggered by {@link ClosingsList#bindEvents}.
 * 
 * @return {void}
 */
window.ClosingsList.prototype.update = function(){
	
	Listing.update(this.type + '_closingsListing');
	return;
};

/**
 * Load one closing into a {@link Panel} instance.
 * 
 * @param {jQuery.Event} event
 * @return {void}
 */
window.ClosingsList.prototype.openPanel = function(event){
	
	var $row	= $(event.currentTarget);
	var panel	= new Panel();
	
	panel.open('pos_' + this.type + 'Closings&action=view&id=' + $row.data('id'));
	return;
};
